/** 顶部数据 */
export const queryStoreTitleCount = '/yuntian/storeCount/queryStoreTitleCount'

/** 店铺订单量排行.成交额排行 */
export const queryStoreRankCount = '/yuntian/storeCount/queryStoreRankCount'

/** 店铺订单量排行.成交额排行 */
export const querySaleCount = '/yuntian/saleOrder/saleCount'

/** 顶部数据 */
export const querySaleItemCount = '/yuntian/saleOrder/saleItemCount'


/**  查询公司账户  参数companyId*/
export const queryCompanyAccountInfo = '/admin/companyAccount/info'

/** 店铺开始 */
/** 查询列表 */
export const queryShopList = '/yuntian/store/queryShopList'

/** 新增 */
export const creatShop = '/yuntian/store/creatShop'

/** 编辑 */
export const modifyShtoreInfo = '/yuntian/store/modifyShtoreInfo'

/** 修改店铺状态 */
export const OperateStoreStatus = '/yuntian/store/OperateStoreStatus'

/** 同步商品 request(`/yuntian/goods/syncStoreGoods/${storeId}`); */
export const syncStoreGoods = '/yuntian/goods/syncStoreGoods/'

/** 店铺授权 */
export const storeAuthorization = '/yuntian/store/storeAuthorization'

/** 手动录入Token/密钥 */
export const manualAuth = '/yuntian/store/manualAuth'
/** 店铺结束 */

/** 同步商品  (storeGoodsId) => request(`/yuntian/goods/syncGoods/${storeGoodsId}`);*/
export const updateStoreGoods = '/yuntian/goods/syncGoods/'

/** 同步店铺内所有商品  (storeId) => request(`/yuntian/goods/syncStoreGoods/${storeId}`);*/
export const updateStoreAllGoods = '/yuntian/goods/syncStoreGoods/'

/** 关联主sku */
export const relationMainSku = '/yuntian/goods/relationMainSku'

/** 批量自动关联主sku */
export const batchRelationMainSku = '/yuntian/goods/batchRelationMainSku'

/** 关联主sku */
export const delMainSku = '/yuntian/goods/delMainSku'

/** 编辑   request(`/admin/update/${id}`, { data });*/
export const editData = '/admin/update/'
/** 查询组合sku下的sku列表 */
export const queryombinationSkuList= '/yuntian/goods/queryombinationSkuList'

/** 编辑仓库sku/组合Sku */
export const modifySku= '/yuntian/goods/modifySku'

/** 新增仓库sku/组合Sku */ 
export const creatSku= '/yuntian/goods/creatSku'

/** 查询主sku关联的 平台sku列表 */
export const getPlatformGoodsList= '/yuntian/goods/getPlatformGoodsList'

/** 关联平台id */
export const relationPlatformGoods= '/yuntian/goods/relationPlatformGoods'

/** 查询列表 */
export const queryGoodsWarehouseList= '/yuntian/warehouseGoods/queryGoodsWarehouseList'

/** 获取库存 */
export const queryStock= '/yuntian/warehouseGoods/queryStock'

/** 设置安全库存 */
export const setSafeStock= '/yuntian/warehouseGoods/setSafeStock'

/** 推送仓库 */
export const pushWarehouse= '/yuntian/returnOrder/pushWarehouse'

/** 订单批量审核 */
export const approvedSaleOrders= '/yuntian/saleOrder/approvedSaleOrders'

/** 取消订单 */
export const cancelSaleOrders= '/yuntian/saleOrder/cancelSaleOrders'

/** 发货 */
export const deiverSaleOrders= '/yuntian/saleOrder/deiverSaleOrders'

/** 修改仓库 */
export const changeWarehouse= '/yuntian/saleOrder/changeWarehouse'

/** 手工同步订单 */
export const synchronizeOrders= '/yuntian/saleOrder/hand-synchronizeOrders'

/** 追加商品 */
export const addSaleOrderItem= '/yuntian/saleOrder/addSaleOrderItem'

/** 重新提交 */
export const reCommitOrder= '/yuntian/saleOrder/reCommitOrder'

/** 订单明细 修改商品数量 */
export const modifySaleOrderItemById= '/yuntian/saleOrder/modifySaleOrderItemById'

/** 替换商品 */
export const changeSaleOrderItemGoods= '/yuntian/saleOrder/changeSaleOrderItemGoods'

/** 自动审核规则列表查询 */
export const autoExamineList= '/yuntian/automaticExamine/list'

/** 自动审核 编辑 */
export const autoExamineEdit= '/yuntian/automaticExamine/edit'

/** 自动审核 删除 request.post(`/yuntian/automaticExamine/del/${id}`);*/
export const autoExamineDel= '/yuntian/automaticExamine/del/'

/** 自动审核 编辑 */
export const autoExamineUpdateStatus= '/yuntian/automaticExamine/updateStatus'

export const autoExamineStatus= '/yuntian/automaticExamine/examineStatus'

/** 自动审核 批量审核历史订单 */
export const autoExamineBatch= '/yuntian/automaticExamine/batchExamine'

/** 自动发货 查询配置 */
export const autoShipGetConfig = '/yuntian/autoShip/config'

/** 自动发货 更新配置 */
export const autoShipUpdateConfig = '/yuntian/autoShip/config/update'

/** 自动发货 规则列表 */
export const autoShipRuleList = '/yuntian/autoShip/rule/list'

/** 自动发货 编辑规则 */
export const autoShipRuleEdit = '/yuntian/autoShip/rule/edit'

/** 自动发货 删除规则 request.post(`/yuntian/autoShip/rule/del/${id}`) */
export const autoShipRuleDel = '/yuntian/autoShip/rule/del/'

/** 设置商品是否推送wms */
export const editSendItem= '/yuntian/saleOrder/editSendItem'

/** 拦截发货 */
export const cancelWmsOrder= '/yuntian/saleOrder/cancelWmsOrder'

/** 获取订单取消的原因 */
export const getCancelReason= '/yuntian/saleOrder/queryCancelReason'

/** 我的账单 */
export const companyBillList= '/account/accountBill/companyBillList'

/** 账单对账 */
export const getDataList= '/account/accountBill/list'

/** 提交支付凭证 */
export const companyCommitBill = '/account/accountBill/companyCommit'

/** 立即生成账单 */
export const createBill = '/account/accountBill/createBill'

/** 其他费用 */
export const queryOtherFeeList = '/account/accountOtherFee/queryOtherFeeList'

/** 其他费用 删除 request.post(`/account/accountOtherFee/delOtherExpenses/${id}`);*/
export const deleteData = '/account/accountOtherFee/delOtherExpenses/'

/** 其他费用 添加 其他&补贴费用*/
export const addStoreOtherFee = '/account/accountOtherFee/addStoreOtherFee'

/** 账户充值   **/ 
export const saveAccount = '/admin/accountOrder/saveAccount'











// WEBPACK FOOTER //
// ./src/http/moudules/bs.js